import React from "react";
import SlideShow from '../components/slideshow/ProjectFourSlide' 

function ProjectFour(){
  const backgroundImage = 'url(../assets/images/213-rosemary-slide.jpg)';

  const style = {
      backgroundImage,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
  };

  return (
 <div>
 
    <div className="project-slider">
        <div className="third-wrapper">
            
            <div className="frame">
            <div id="projectSlideImg" style={style}>
                <div className="img-fade"></div>
                </div>
                <div className="wrapper">
                    <div className="project-slide-des">
                        <h1>Forest Hill South</h1>
                        <p>213 Rosemary Rd, Toronto, M5P 3E2.</p>
                    </div>
                </div>
            </div>     
        </div> 
    </div>
 
  
        <section className="project">
            <div className="divider-project">
                <div className="project-des">
                    <h2>Project Details</h2>
                    <p><strong>Lot:</strong> 40' x 130'</p>
                    <p><strong>Total SQF:</strong> 7,201 Sqf</p>
                    <p><strong>Location:</strong> 213 Rosemary Rd, Toronto, M5P 3E2.</p>
                    <p><strong>Status:</strong> Permit</p>
                    <p><strong>Architect:</strong> Richard Wengle Architects</p>
                    <p><strong>Interior:</strong> Winse Nadel</p>
                </div>

            </div>
        </section>
        
 
        <div className="project-leadership-img">
            <div className="img-construction">
                <img src="../assets/images/home-birds.png" alt="home construction"/>
            </div>   
        </div>
 
    <div className="wrapper">
      <section className="project-des-section">

        <h3>Project Description</h3>
        <p>Description</p>

      </section>
    </div>

    <div className="wrapper">
        <section className="project-section">

                <SlideShow/>
          
        </section>
    </div>

 
    </div>
  );
}

export default ProjectFour;